if not App.angularApp?
    return

# Put this on the table element
App.angularApp.directive 'mfKeyboardTableNav', ->
    restrict: 'A'
    link: (scope, ele, attrs) ->
        KEYS =
            up: 38
            down: 40
            enter: 13

        focusOnEle = (e, cb) ->
            e.preventDefault()
            $target = $(e.target)
            parent = $target.parent('td')[0]
            row = $target.parents 'tr'

            columns = $.makeArray row.find 'td'
            columnNumber = columns.indexOf parent

            nextRow = cb row

            nextColumn = nextRow.find('td').eq columnNumber
            nextColumn.find('input').focus()

        ele.on 'keydown', (e) ->
            switch e.keyCode
                when KEYS.up
                    focusOnEle e, (row) ->
                        return row.prev()
                when KEYS.down, KEYS.enter
                    focusOnEle e, (row) ->
                        return row.next()

